module.exports = __webpack_public_path__ + "static/media/favorite.fb2374ff.svg";